import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getDashboard, getUltimaEstrazione, getRitardi } from '../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [ultimaEstrazione, setUltimaEstrazione] = useState([]);
  const [topRitardi, setTopRitardi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [dashRes, estrRes, ritardiRes] = await Promise.all([
        getDashboard(),
        getUltimaEstrazione(),
        getRitardi(null, 10)
      ]);
      setStats(dashRes.data);
      setUltimaEstrazione(estrRes.data);
      setTopRitardi(ritardiRes.data);
    } catch (err) {
      console.error('Errore caricamento dashboard:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>Dashboard</h2>
      
      {/* Stats Cards */}
      <div className="grid grid-4" style={{ marginBottom: '30px' }}>
        <div className="stat-card">
          <div className="stat-value">{stats?.totale_giocate || 0}</div>
          <div className="stat-label">Giocate Totali</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">€{stats?.totale_speso?.toFixed(2) || '0.00'}</div>
          <div className="stat-label">Totale Speso</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">€{stats?.totale_vinto?.toFixed(2) || '0.00'}</div>
          <div className="stat-label">Totale Vinto</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: stats?.roi >= 0 ? '#38a169' : '#e53e3e' }}>
            {stats?.roi?.toFixed(1) || '0.0'}%
          </div>
          <div className="stat-label">ROI</div>
        </div>
      </div>

      <div className="grid grid-2">
        {/* Ultima Estrazione */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Ultima Estrazione</h3>
            {ultimaEstrazione[0] && (
              <span style={{ color: '#718096' }}>{ultimaEstrazione[0].data}</span>
            )}
          </div>
          
          {ultimaEstrazione.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Ruota</th>
                  <th>Numeri</th>
                </tr>
              </thead>
              <tbody>
                {ultimaEstrazione.map((e) => (
                  <tr key={e.id}>
                    <td><span className="ruota-badge">{e.ruota_nome}</span></td>
                    <td>
                      <span className="numero-ball small">{e.numero1}</span>
                      <span className="numero-ball small">{e.numero2}</span>
                      <span className="numero-ball small">{e.numero3}</span>
                      <span className="numero-ball small">{e.numero4}</span>
                      <span className="numero-ball small">{e.numero5}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#718096' }}>Nessuna estrazione disponibile</p>
          )}
        </div>

        {/* Top Ritardatari */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Top 10 Ritardatari</h3>
            <Link to="/statistiche" className="btn btn-secondary">
              Vedi tutti
            </Link>
          </div>
          
          {topRitardi.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Numero</th>
                  <th>Ruota</th>
                  <th>Ritardo</th>
                </tr>
              </thead>
              <tbody>
                {topRitardi.map((r, idx) => (
                  <tr key={idx}>
                    <td><span className="numero-ball small">{r.numero}</span></td>
                    <td><span className="ruota-badge">{r.ruota_nome}</span></td>
                    <td><strong>{r.ritardo_attuale}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#718096' }}>Nessuna statistica disponibile</p>
          )}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="card" style={{ marginTop: '20px' }}>
        <h3 className="card-title" style={{ marginBottom: '15px' }}>Azioni Rapide</h3>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <Link to="/ipotesi" className="btn btn-primary">
            ✨ Nuova Ipotesi
          </Link>
          <Link to="/giocate" className="btn btn-success">
            🎯 Nuova Giocata
          </Link>
          <Link to="/statistiche" className="btn btn-secondary">
            📊 Analizza Statistiche
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
